export const environment = {
	useProxy: false,
	production: false
};
